import type { CustomTooltipProps } from '@cmg/data-grid';
import { Stack } from '@cmg/design-system';
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { AlertGroup } from './AlertGroup';
import { getAlertGroups } from './TooltipContent.model';

type OwnProps = {
  complianceDetailsPath: string;
  alertCodes: readonly string[];
};

export type Props = OwnProps & Pick<CustomTooltipProps, 'hideTooltipCallback'>;

export const TooltipContentComponent: React.FC<Props> = ({
  alertCodes,
  complianceDetailsPath,
  hideTooltipCallback,
}) => {
  const [complianceAlerts, deliveryAlerts, acknowledgementsAlerts, allocationAlerts] = useMemo(
    () => getAlertGroups(alertCodes),
    [alertCodes]
  );

  if (alertCodes.length === 0) {
    return null;
  }

  return (
    <Stack width={200} gap={2}>
      <AlertGroup
        alertMessages={complianceAlerts}
        title={
          <React.Fragment>
            Compliance{' '}
            <Link
              to={complianceDetailsPath}
              onClick={() => {
                hideTooltipCallback?.();
              }}
            >
              View details
            </Link>
          </React.Fragment>
        }
      />
      <AlertGroup alertMessages={deliveryAlerts} title="B&D Agent" />
      <AlertGroup alertMessages={acknowledgementsAlerts} title="IOI Acknowledgements" />
      <AlertGroup alertMessages={allocationAlerts} title="Allocation" />
    </Stack>
  );
};
